(function(){'use strict';function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}var CART_DRAWER_SELECTOR="#cart-drawer",GREETING_CARD_SELECTOR="[data-greeting-card]",OPTION_2_SELECTOR="[data-greeting-card-option-2]",RADIO_NAME="greeting-card-option",FORM_SELECTOR="[data-greeting-card-form]",SUBMIT_WRAP_SELECTOR="[data-greeting-card-submit-wrap]",ID_INPUT_SELECTOR='input[name="id"]',HINT_SELECTOR="[data-greeting-card-hint]",TEXT_HINT_SELECTOR="[data-greeting-card-text-hint]",SUBMIT_SELECTOR=".greeting-card__submit",MESSAGE_SELECTOR="[data-greeting-card-message]",TEXTAREA_SELECTOR="[data-greeting-card-textarea]",CHAR_COUNT_SELECTOR="[data-greeting-card-char-count]",EDIT_BUTTON_SELECTOR="[data-greeting-card-edit]",EDIT_MESSAGE_TEMPLATE="template[data-greeting-card-edit-message]",MESSAGE_PROPERTY="_greeting_text",MAX_CHARS=200,MESSAGE_TRANSITION_MS=250,closeTimeouts=new WeakMap;function bundleSections(){var e=new Set;return document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections",{bubbles:!0,detail:{sections:e}})),e}function setLoading(e){document.documentElement.dispatchEvent(new CustomEvent(e?"theme:loading:start":"theme:loading:end",{bubbles:!0}));}function dispatchCartChange(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"greeting-card:edit";document.documentElement.dispatchEvent(new CustomEvent("cart:change",{bubbles:!0,detail:{baseEvent:t,cart:e}}));}function getGreetingCard(){return document.querySelector("".concat(CART_DRAWER_SELECTOR," ").concat(GREETING_CARD_SELECTOR))}function isOption2Variant(e,t){var n;return String(t)===String(null!==(n=null==e?void 0:e.dataset.opt2VariantId)&&void 0!==n?n:"")}function getEditMessage(e){var t,n=e.querySelector(EDIT_MESSAGE_TEMPLATE);return n?(n.innerHTML||(null===(t=n.content)||void 0===t?void 0:t.textContent)||"").trim():""}function findLineItemForEdit(e){var t=document.querySelector("".concat(CART_DRAWER_SELECTOR," ").concat(EDIT_BUTTON_SELECTOR,'[data-line-key="').concat(e,'"]'));return null==t?void 0:t.closest("line-item")}function showLineError(e,t){var n=null==e?void 0:e.querySelector(".line-item__error-container");n&&(n.innerHTML="",t&&n.insertAdjacentHTML("afterbegin",'<p class="h-stack gap-1.5 text-sm text-error" role="alert">'.concat(t,"</p>")));}function buildProperties(e,t){var n=e?(null!=t?t:"").trim():"";return n?_defineProperty({},MESSAGE_PROPERTY,n):{}}function fetchCartWithSections(e){return _fetchCartWithSections.apply(this,arguments)}function _fetchCartWithSections(){return (_fetchCartWithSections=_asyncToGenerator(_regeneratorRuntime().mark((function e(t){var n;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,fetch("".concat(Shopify.routes.root,"cart.js"));case 2:return e.next=4,e.sent.json();case 4:return n=e.sent,t&&(n.sections=t),e.abrupt("return",n);case 7:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function updateGreetingLineProperties(e){return _updateGreetingLineProperties.apply(this,arguments)}function _updateGreetingLineProperties(){return (_updateGreetingLineProperties=_asyncToGenerator(_regeneratorRuntime().mark((function e(t){var n,r,a,i,o,s,c;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=t.lineKey,r=t.quantity,a=t.message,i=t.isOption2,o=bundleSections(),e.next=4,fetch("".concat(Shopify.routes.root,"cart/change.js"),{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:n,quantity:r,properties:buildProperties(i,a),sections:_toConsumableArray(o).join(",")})});case 4:if((s=e.sent).ok){e.next=10;break}return e.next=8,s.json();case 8:throw c=e.sent,new Error(c.description||c.message||"");case 10:return e.abrupt("return",s.json());case 11:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function swapGreetingLineVariant(e){return _swapGreetingLineVariant.apply(this,arguments)}function _swapGreetingLineVariant(){return (_swapGreetingLineVariant=_asyncToGenerator(_regeneratorRuntime().mark((function e(t){var n,r,a,i,o,s,c,u,d,l,E,S;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=t.lineKey,r=t.quantity,a=t.variantId,i=t.message,o=t.isOption2,s=bundleSections(),c=_toConsumableArray(s).join(","),e.next=5,fetch("".concat(Shopify.routes.root,"cart/change.js"),{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:n,quantity:0,sections:c})});case 5:if((u=e.sent).ok){e.next=11;break}return e.next=9,u.json();case 9:throw d=e.sent,new Error(d.description||d.message||"");case 11:return (l=new FormData).set("id",a),l.set("quantity",String(r)),o&&i&&l.set("properties[".concat(MESSAGE_PROPERTY,"]"),i),c&&l.set("sections",c),e.next=18,fetch("".concat(Shopify.routes.root,"cart/add.js"),{method:"POST",headers:{"X-Requested-With":"XMLHttpRequest"},body:l});case 18:if((u=e.sent).ok){e.next=24;break}return e.next=22,u.json();case 22:throw E=e.sent,new Error(E.description||E.message||"");case 24:return e.next=26,u.json();case 26:return S=e.sent,e.abrupt("return",fetchCartWithSections(S.sections));case 28:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function hasRadioSelection(e){return Boolean(null==e?void 0:e.querySelector('input[name="'.concat(RADIO_NAME,'"]:checked')))}function getCheckedRadio(e,t){return (null==t?void 0:t.name)===RADIO_NAME?t:null==e?void 0:e.querySelector('input[name="'.concat(RADIO_NAME,'"]:checked'))}function isOption2Selected(e,t){var n=getCheckedRadio(e,t);return Boolean(null==n?void 0:n.closest(OPTION_2_SELECTOR))}function hasMessageText(e){var t=null==e?void 0:e.querySelector(TEXTAREA_SELECTOR);return Boolean(null==t?void 0:t.value.trim().length)}function hideHints(e){var t=null==e?void 0:e.querySelector(HINT_SELECTOR),n=null==e?void 0:e.querySelector(TEXT_HINT_SELECTOR);t&&(t.hidden=!0),n&&(n.hidden=!0);}function updateSubmitState(e){var t=null==e?void 0:e.querySelector(FORM_SELECTOR),n=null==t?void 0:t.querySelector(SUBMIT_SELECTOR);n&&(hasRadioSelection(e)?isOption2Selected(e)?n.disabled=!hasMessageText(e):n.disabled=!1:n.disabled=!0);}function updateCharCount(e){var t=null==e?void 0:e.querySelector(TEXTAREA_SELECTOR),n=null==e?void 0:e.querySelector(CHAR_COUNT_SELECTOR);t&&n&&(n.textContent="".concat(t.value.length,"/").concat(MAX_CHARS));}function clearCloseTimeout(e){var t=closeTimeouts.get(e);t&&(window.clearTimeout(t),closeTimeouts.delete(e));}function closeMessagePanel(e){var t=null==e?void 0:e.querySelector(MESSAGE_SELECTOR),n=null==e?void 0:e.querySelector(TEXTAREA_SELECTOR);t&&(clearCloseTimeout(t),t.classList.remove("is-open"),closeTimeouts.set(t,window.setTimeout((function(){closeTimeouts.delete(t),t.classList.contains("is-open")||(t.hidden=!0);}),MESSAGE_TRANSITION_MS)),n&&(n.value="",n.disabled=!0,updateCharCount(e)));}function openMessagePanel(e){var t=null==e?void 0:e.querySelector(MESSAGE_SELECTOR),n=null==e?void 0:e.querySelector(TEXTAREA_SELECTOR);t&&(clearCloseTimeout(t),t.hidden=!1,requestAnimationFrame((function(){t.classList.add("is-open");})),n&&(n.disabled=!1,updateCharCount(e)));}function updateMessagePanel(e,t){isOption2Selected(e,t)?openMessagePanel(e):closeMessagePanel(e);}function updateFromRadio(e){var t=e.closest(GREETING_CARD_SELECTOR);if(t){var n=t.querySelector(FORM_SELECTOR),r=null==n?void 0:n.querySelector(ID_INPUT_SELECTOR);r&&(r.value=e.value),hideHints(t),updateMessagePanel(t,e),updateSubmitState(t);}}function resetEditMode(){var e=getGreetingCard();if(e){delete e.dataset.editingLineKey,delete e.dataset.editingVariantId,delete e.dataset.editingQuantity;for(var t=e.querySelectorAll('input[name="'.concat(RADIO_NAME,'"]')),n=0;n<t.length;n+=1)t[n].checked=!1;var r=e.querySelector(ID_INPUT_SELECTOR);r&&(r.value=""),closeMessagePanel(e),hideHints(e),updateSubmitState(e),document.querySelector("".concat(CART_DRAWER_SELECTOR," .line-item--with-greeting-card"))&&e.setAttribute("hidden","");}}function startEdit(e){var t=getGreetingCard();if(t){var n=e.dataset,r=n.lineKey,a=n.variantId,i=n.lineQuantity,o=parseInt(i,10)||1,s=getEditMessage(e);t.dataset.editingLineKey=r,t.dataset.editingVariantId=a,t.dataset.editingQuantity=String(o),t.removeAttribute("hidden"),t.open=!0;var c=t.querySelector('input[name="'.concat(RADIO_NAME,'"][value="').concat(a,'"]'));if(c&&(c.checked=!0,updateFromRadio(c)),isOption2Variant(t,a)){var u=t.querySelector(TEXTAREA_SELECTOR);u&&(u.value=s,updateCharCount(t));}hideHints(t),updateSubmitState(t),t.scrollIntoView({block:"nearest",behavior:"smooth"});}}function initGreetingCard(e){var t=e.querySelector('input[name="'.concat(RADIO_NAME,'"]:checked')),n=e.querySelector(FORM_SELECTOR),r=null==n?void 0:n.querySelector(ID_INPUT_SELECTOR);hideHints(e),r&&t&&(r.value=t.value),isOption2Selected(e,t)?openMessagePanel(e):closeMessagePanel(e),updateSubmitState(e);}function init(){document.querySelectorAll("".concat(CART_DRAWER_SELECTOR," ").concat(GREETING_CARD_SELECTOR)).forEach(initGreetingCard);}function onGreetingFormSubmit(e){return _onGreetingFormSubmit.apply(this,arguments)}function _onGreetingFormSubmit(){return (_onGreetingFormSubmit=_asyncToGenerator(_regeneratorRuntime().mark((function e(t){var n,r,a,i,o,s,c,u,d,l,E,S,T;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if((r=t.target)instanceof HTMLFormElement){e.next=3;break}return e.abrupt("return");case 3:if(null!=(a=r.closest(GREETING_CARD_SELECTOR))&&a.dataset.editingLineKey){e.next=6;break}return e.abrupt("return");case 6:if(t.preventDefault(),t.stopImmediatePropagation(),i=a.dataset.editingLineKey,o=a.dataset.editingVariantId,s=parseInt(a.dataset.editingQuantity,10)||1,c=getCheckedRadio(a),u=null==c?void 0:c.value,d=isOption2Selected(a),l=a.querySelector(TEXTAREA_SELECTOR),E=d&&null!==(n=null==l?void 0:l.value.trim())&&void 0!==n?n:"",u){e.next=18;break}return e.abrupt("return");case 18:if(!d||E){e.next=20;break}return e.abrupt("return");case 20:if(showLineError(S=findLineItemForEdit(i),""),e.prev=22,setLoading(!0),String(u)===String(o)){e.next=30;break}return e.next=27,swapGreetingLineVariant({lineKey:i,quantity:s,variantId:u,message:E,isOption2:d});case 27:T=e.sent,e.next=33;break;case 30:return e.next=32,updateGreetingLineProperties({lineKey:i,quantity:s,message:E,isOption2:d});case 32:T=e.sent;case 33:resetEditMode(),a.open=!1,dispatchCartChange(T),e.next=41;break;case 38:e.prev=38,e.t0=e.catch(22),showLineError(S,e.t0.message);case 41:return e.prev=41,setLoading(!1),e.finish(41);case 44:case"end":return e.stop()}}),e,null,[[22,38,41,44]])})))).apply(this,arguments)}function onDocumentChange(e){var t=e.target;"radio"===t.type&&t.name===RADIO_NAME&&t.closest(CART_DRAWER_SELECTOR)&&updateFromRadio(t);}function onDocumentInput(e){var t=e.target;if(t.matches(TEXTAREA_SELECTOR)&&t.closest(CART_DRAWER_SELECTOR)){t.value.length>MAX_CHARS&&(t.value=t.value.slice(0,MAX_CHARS));var n=t.closest(GREETING_CARD_SELECTOR);if(updateCharCount(n),hasMessageText(n)){var r=null==n?void 0:n.querySelector(TEXT_HINT_SELECTOR);r&&(r.hidden=!0);}updateSubmitState(n);}}function onDocumentClick(e){var t=e.target.closest(EDIT_BUTTON_SELECTOR);if(null!=t&&t.closest(CART_DRAWER_SELECTOR))return e.preventDefault(),void startEdit(t);var n=e.target.closest("".concat(CART_DRAWER_SELECTOR," ").concat(SUBMIT_WRAP_SELECTOR));if(n){var r=n.closest(GREETING_CARD_SELECTOR);if(r){var a=n.querySelector(SUBMIT_SELECTOR);if(null!=a&&a.disabled){var i=r.querySelector(HINT_SELECTOR),o=r.querySelector(TEXT_HINT_SELECTOR);if(!hasRadioSelection(r))return i&&(i.hidden=!1),void(o&&(o.hidden=!0));isOption2Selected(r)&&!hasMessageText(r)&&(o&&(o.hidden=!1),i&&(i.hidden=!0));}}}}function onDetailsToggle(e){var t=e.target;t.matches(GREETING_CARD_SELECTOR)&&!t.open&&t.dataset.editingLineKey&&resetEditMode();}document.addEventListener("submit",onGreetingFormSubmit,!0),document.addEventListener("change",onDocumentChange),document.addEventListener("input",onDocumentInput),document.addEventListener("click",onDocumentClick),document.addEventListener("toggle",onDetailsToggle),document.addEventListener("DOMContentLoaded",init),document.addEventListener("cart-drawer:refreshed",init),document.addEventListener("shopify:section:load",(function(e){var t,n;null!==(t=e.target)&&void 0!==t&&null!==(n=t.querySelector)&&void 0!==n&&n.call(t,CART_DRAWER_SELECTOR)&&init();}));})();